import { Link, useLocation, useNavigate } from "react-router";
import { createClient } from "@/lib/supabase/client";
import { APP_NAME } from "@/lib/constants";

const NAV_LINKS = [
  { href: "/stocks", label: "Coverage" },
  { href: "/attention", label: "My List" },
  { href: "/settings", label: "Settings" },
] as const;

export function Nav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  async function handleLogOut() {
    const supabase = createClient();
    await supabase.auth.signOut();
    navigate("/login");
  }

  return (
    <nav
      className="hidden md:flex items-center justify-between border-b border-border bg-background px-6 py-3"
      role="navigation"
      aria-label="Main navigation"
    >
      <Link
        to="/stocks"
        className="flex items-center gap-3 no-underline"
        aria-label={`${APP_NAME} home`}
      >
        <img
          src="/logo.png"
          alt=""
          width={36}
          height={36}
          className="rounded"
          aria-hidden="true"
        />
        <span className="text-xl font-[family-name:var(--font-heading)] text-foreground">
          {APP_NAME}
        </span>
      </Link>

      <div className="flex items-center gap-1">
        {NAV_LINKS.map((link) => {
          const isActive =
            pathname === link.href || pathname.startsWith(link.href + "/");

          return (
            <Link
              key={link.href}
              to={link.href}
              className={`relative px-4 py-2 text-lg no-underline transition-colors rounded-lg hover:bg-muted ${
                isActive
                  ? "text-primary font-medium"
                  : "text-muted-foreground"
              }`}
              aria-current={isActive ? "page" : undefined}
            >
              {link.label}
              {isActive && (
                <span
                  className="absolute bottom-0 left-2 right-2 h-0.5 rounded-full bg-primary"
                  aria-hidden="true"
                />
              )}
            </Link>
          );
        })}

        <button
          onClick={handleLogOut}
          className="ml-4 px-4 py-2 text-lg text-muted-foreground hover:text-foreground transition-colors cursor-pointer rounded-lg hover:bg-muted"
          type="button"
        >
          Log out
        </button>
      </div>
    </nav>
  );
}
